import { createContext, useContext } from "react"
import type { Source } from "../../contract"

/** Where a block lives: its turn, section and the sources that turn has so far. */
export interface BlockScope {
  turn: string
  section: string
  sources: Record<string, Source>
  /** Card-level citation numbers: each source gets the next number at its first mention. */
  citeNo: Record<string, number>
}

export const BlockScopeContext = createContext<BlockScope>({ turn: "", section: "", sources: {}, citeNo: {} })
export const useBlockScope = () => useContext(BlockScopeContext)
